module.exports = __webpack_public_path__ + "img/IMG_2349-14307.d1b91e28.jpg";